/**
 * Email Value Object
 * Ensures email addresses are valid
 */
export class Email {
  private readonly _value: string;

  constructor(email: string) {
    if (!Email.isValid(email)) {
      throw new Error(`Invalid email address: ${email}`);
    }
    this._value = email.toLowerCase().trim();
  }

  get value(): string {
    return this._value;
  }

  static isValid(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

  equals(other: Email): boolean {
    return this._value === other._value;
  }

  toString(): string {
    return this._value;
  }
}
